import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/material/material.module';
import { FormsModule } from '../forms/forms.module';
import { PasswordConfirmationDialogComponent } from './password-confirmation-dialog.component';

@NgModule({
    declarations: [PasswordConfirmationDialogComponent],
    imports: [CommonModule, MaterialModule, FormsModule],
    exports: [PasswordConfirmationDialogComponent],
})
export class PasswordConfirmationDialogModule {}
